import { HelpButton } from "@cdkglobal/radial";
import { useIntl } from "react-intl";

export const WalkMeHelpButton = ({
  isCollapsed,
}: {
  isCollapsed: boolean;
}): JSX.Element => {
  const intl = useIntl();

  const openWalkMe = (event: React.PointerEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (window.WalkMePlayerAPI) {
      window.WalkMePlayerAPI.toggleMenu();
    } else {
      console.error(
        "WalkMePlayerAPI is not loaded. Please check if the WalkMe script is correctly loaded in <head>.",
      );
    }
  };

  return (
    <HelpButton
      label={intl.formatMessage({ id: "button.help", defaultMessage: "Help" })}
      isCollapsed={isCollapsed}
      onClick={openWalkMe}
    />
  );
};
